module.exports = __webpack_public_path__ + "img/retweet.08f80902.svg";